<template>

  <div>

    <div class="d-flex justify-space-around align-center mt-8 mb-8 mx-3">

      <div style="width: 100px;" class="d-flex justify-center">
        <v-avatar color="info" size="80">
          <v-icon x-large dark>{{ icon }}</v-icon>
        </v-avatar>
      </div>


      <div v-if="title !== null || subtitle !== null">
        <v-card-title class="mt-0 pt-0" v-if="title !== null">{{ title }}</v-card-title>
        <v-card-subtitle class="pb-0" v-if="subtitle !== null">{{ subtitle }}</v-card-subtitle>

        <slot></slot>

      </div>


    </div>

  </div>
</template>

<script>
export default {
  name: "PlingDialogHeader",
  props: {

    icon: {required: false, default: 'mdi-help', type: String},
    title: {required: false, default: null, type: String},
    subtitle: {required: false, default: null, type: String},

  }
}
</script>



<style scoped lang="scss">

</style>